import moment from 'moment-timezone';
import {Record, List, Map} from 'immutable';

import {activityLinksToEmbed} from 'web-app/react/feed/post/new-post/helpers';
import {hasValue} from 'web-app/util/typescript';

const Sender = Record({
    id: undefined,
    loginId: undefined,
    name: undefined,
    profileImage: undefined,
    subtitle: undefined,
});

const Video = Record({
    videoId: undefined,
    videoUrl: undefined,
    thumbnailUrl: undefined,
    width: undefined,
    transcoding: undefined,
    height: undefined,
});

const File = Record({
    fileId: undefined,
    filename: undefined,
    url: undefined,
});

const Like = Record({
    loginId: '',
    name: '',
    profileImage: '',
    subtitle: '',
});

const Stats = Record({
    total: 0,
    seen: 0,
});

const likeFromAPI = like => new Like(like);

const Comment = Record({
    body: '',
    commentId: '',
    createdDate: moment(),
    liked: false,
    liking: false,
    deleting: false,
    likes: List(),
    owner: false,
    sender: new Sender(),
    showDeleteLink: false,
    images: List(),
    canReport: false,
});

const commentFromAPI = comment =>
    new Comment({
        ...comment,
        createdDate: moment(comment.createdDate),
        likes: List(comment.likes).map(likeFromAPI),
        sender: new Sender(comment.sender),
        images: List(comment.images),
    });

const FeedItem = Record({
    feedItemId: '',
    body: '',
    richTextBody: undefined,
    nextStep: undefined,
    richNextStep: undefined,
    bookmarked: false,
    bookmarking: false,
    canDelete: false,
    canEdit: false,
    canReport: false,
    canBlock: false,
    canBookmark: false,
    commenting: false,
    comments: List(),
    createdDate: undefined,
    disableFeedback: false,
    embed: Map(),
    files: List(),
    images: List(),
    liked: false,
    originatorId: '',
    receivers: List(),
    likes: List(),
    seen: false,
    stats: null,
    sender: new Sender(),
    thumbs: List(),
    variant: '',
    videos: List(),
    siteSetId: undefined,
    systemPostTypeClass: undefined,
    systemPostTypeIcon: undefined,
    smsIdentifier: null,
    famlyMeetingId: '',
});

function fromAPI(data) {
    return new FeedItem({
        ...data,
        stats: data.stats ? new Stats(data.stats) : null,
        sender: new Sender(data.sender),
        comments: List(data.comments).map(commentFromAPI),
        likes: List(data.likes).map(likeFromAPI),
        images: List(data.images),
        receivers: List(data.receivers),
        videos: List(data.videos).map(v => new Video(v)),
        files: List(data.files).map(f => new File(f)),
        embed: Map(data.embed),
    });
}

export const combineFeedItemWithPost = (feedItem, post) => {
    const maybeActivityEmbed = activityLinksToEmbed(post.activities);
    return feedItem.merge({
        body: post.body,
        richTextBody: post.richTextBody,
        disableFeedback: post.disableFeedback,
        images: List(post.images),
        videos: List(post.videos).map(v => new Video(v)),
        files: List(post.files).map(f => new File(f)),
        embed: hasValue(maybeActivityEmbed) ? maybeActivityEmbed : feedItem.embed,
    });
};

export default {
    record: FeedItem,
    default: new FeedItem(),
    commentFromAPI,
    likeFromAPI,
    fromAPI,
    Sender,
};
